import { useOffline } from '@/hooks/useOffline'
import { WifiOff, RefreshCw } from 'lucide-react'

export function OfflineIndicator() {
  const { isOffline, hasPendingSync, pendingSync } = useOffline()

  if (!isOffline && !hasPendingSync) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {isOffline && (
        <div className="bg-destructive text-destructive-foreground px-4 py-2 text-center text-sm flex items-center justify-center gap-2">
          <WifiOff className="w-4 h-4" />
          <span>You're offline. Some features may be limited.</span>
        </div>
      )}
      {hasPendingSync && !isOffline && (
        <div className="bg-warning text-warning-foreground px-4 py-2 text-center text-sm flex items-center justify-center gap-2">
          <RefreshCw className="w-4 h-4 animate-spin" />
          <span>Syncing {pendingSync} pending action{pendingSync > 1 ? 's' : ''}...</span>
        </div>
      )}
    </div>
  )
}
